function getLevelInfo(score) {
  if (score >= 0 && score <= 5) {
    return { level: "А1 - А2", key: "A1A2" };
  } else if (score >= 6 && score <= 10) {
    return { level: "А2 - В1", key: "A2B1" };
  } else if (score >= 11 && score <= 17) {
    return { level: "В1 - В2", key: "B1B2" };
  } else if (score >= 18 && score <= 24) {
    return { level: "В1+ - В2", key: "B1plusB2" };
  } else if (score >= 25 && score <= 34) {
    return { level: "В2 - С1", key: "B2C1" };
  } else if (score >= 35 && score <= 40) {
    return { level: "С1-С2", key: "C1C2" };
  } else {
    return null;
  }
}

export default getLevelInfo;
